/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfListOfGetVoiceMessageGroupsListDto } from '../models/custom-result-of-list-of-get-voice-message-groups-list-dto';
import { CustomResultOfPaginatedListOfGetVoiceMessageGroupsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-voice-message-groups-with-pagination-dto';
import { voiceMessageGroupsCreate } from '../fn/voice-message-groups/voice-message-groups-create';
import { VoiceMessageGroupsCreate$Params } from '../fn/voice-message-groups/voice-message-groups-create';
import { voiceMessageGroupsDelete } from '../fn/voice-message-groups/voice-message-groups-delete';
import { VoiceMessageGroupsDelete$Params } from '../fn/voice-message-groups/voice-message-groups-delete';
import { voiceMessageGroupsGetVoiceMessageGroupsList } from '../fn/voice-message-groups/voice-message-groups-get-voice-message-groups-list';
import { VoiceMessageGroupsGetVoiceMessageGroupsList$Params } from '../fn/voice-message-groups/voice-message-groups-get-voice-message-groups-list';
import { voiceMessageGroupsGetVoiceMessageGroupsWithPagination } from '../fn/voice-message-groups/voice-message-groups-get-voice-message-groups-with-pagination';
import { VoiceMessageGroupsGetVoiceMessageGroupsWithPagination$Params } from '../fn/voice-message-groups/voice-message-groups-get-voice-message-groups-with-pagination';
import { voiceMessageGroupsUpdate } from '../fn/voice-message-groups/voice-message-groups-update';
import { VoiceMessageGroupsUpdate$Params } from '../fn/voice-message-groups/voice-message-groups-update';

@Injectable({ providedIn: 'root' })
export class VoiceMessageGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `voiceMessageGroupsCreate()` */
  static readonly VoiceMessageGroupsCreatePath = '/VoiceMessageGroups/Create';

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessageGroupsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsCreate$Response(params: VoiceMessageGroupsCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessageGroupsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessageGroupsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsCreate(params: VoiceMessageGroupsCreate$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessageGroupsCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessageGroupsUpdate()` */
  static readonly VoiceMessageGroupsUpdatePath = '/VoiceMessageGroups/Update';

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessageGroupsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsUpdate$Response(params: VoiceMessageGroupsUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessageGroupsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessageGroupsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsUpdate(params: VoiceMessageGroupsUpdate$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessageGroupsUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessageGroupsDelete()` */
  static readonly VoiceMessageGroupsDeletePath = '/VoiceMessageGroups/Delete';

  /**
   * حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessageGroupsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsDelete$Response(params: VoiceMessageGroupsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessageGroupsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessageGroupsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsDelete(params: VoiceMessageGroupsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessageGroupsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessageGroupsGetVoiceMessageGroupsWithPagination()` */
  static readonly VoiceMessageGroupsGetVoiceMessageGroupsWithPaginationPath = '/VoiceMessageGroups/GetVoiceMessageGroupsWithPagination';

  /**
   * دریافت با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessageGroupsGetVoiceMessageGroupsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsGetVoiceMessageGroupsWithPagination$Response(params: VoiceMessageGroupsGetVoiceMessageGroupsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetVoiceMessageGroupsWithPaginationDto>> {
    return voiceMessageGroupsGetVoiceMessageGroupsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessageGroupsGetVoiceMessageGroupsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessageGroupsGetVoiceMessageGroupsWithPagination(params: VoiceMessageGroupsGetVoiceMessageGroupsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetVoiceMessageGroupsWithPaginationDto> {
    return this.voiceMessageGroupsGetVoiceMessageGroupsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetVoiceMessageGroupsWithPaginationDto>): CustomResultOfPaginatedListOfGetVoiceMessageGroupsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `voiceMessageGroupsGetVoiceMessageGroupsList()` */
  static readonly VoiceMessageGroupsGetVoiceMessageGroupsListPath = '/VoiceMessageGroups/GetVoiceMessageGroupsList';

  /**
   * دریافت لیستی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessageGroupsGetVoiceMessageGroupsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessageGroupsGetVoiceMessageGroupsList$Response(params?: VoiceMessageGroupsGetVoiceMessageGroupsList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetVoiceMessageGroupsListDto>> {
    return voiceMessageGroupsGetVoiceMessageGroupsList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیستی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessageGroupsGetVoiceMessageGroupsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessageGroupsGetVoiceMessageGroupsList(params?: VoiceMessageGroupsGetVoiceMessageGroupsList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetVoiceMessageGroupsListDto> {
    return this.voiceMessageGroupsGetVoiceMessageGroupsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetVoiceMessageGroupsListDto>): CustomResultOfListOfGetVoiceMessageGroupsListDto => r.body)
    );
  }

}
